import { render, staticRenderFns } from "./DonutChart52.vue?vue&type=template&id=1a4291bd&scoped=true&"
import script from "./DonutChart52.vue?vue&type=script&lang=js&"
export * from "./DonutChart52.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4291bd",
  null
  
)

export default component.exports